export default "__VITE_ASSET__Bv$kMhil__"